import React, { useState } from 'react';
import { AlertV2, Button } from 'gatorcomponents';
import { useDispatch } from 'react-redux';
import * as Styles from './Ticket.styles';
import { getBoletoUrl } from '@/redux/actions/invoices';
import { CALLER } from '../../usePaymentModal.types';

const Ticket = ({
  invoice = null,
  setTicketData,
  description,
  buttonLabel,
  handleSwitchPaymentMethod,
  loadingSwitchPaymentMethod,
  caller,
}) => {
  const [loading, setLoading] = useState();
  const dispatch = useDispatch();

  const generateTicket = async () => {
    if (caller === CALLER.SUBSCRIPTIONS) {
      handleSwitchPaymentMethod();
      return;
    }

    if (invoice && invoice.id) {
      setLoading(true);
      dispatch(getBoletoUrl(invoice.id)).then((response) => {
        setTicketData(response.dataCheck.data);
      });
    }
  };

  return (
    <>
      <Styles.Wrapper>
        <Styles.AlertContent>
          <AlertV2
            hasIcon={false}
            width="full"
          >
            {description()}
          </AlertV2>
        </Styles.AlertContent>
        <Button
          label={buttonLabel}
          onClick={generateTicket}
          size="medium2"
          width="fit-content"
          loading={loading || loadingSwitchPaymentMethod}
          disabled={loading || loadingSwitchPaymentMethod}
        />
      </Styles.Wrapper>
    </>
  );
};

export default Ticket;
